/* Avatar: initials on a tint picked from the name, so each person keeps a colour. */
import { cn } from '@/lib/cn'

const TINTS = [
  'bg-brand-100 text-brand-800',
  'bg-teal-100 text-teal-700',
  'bg-indigo-100 text-indigo-700',
  'bg-warm-100 text-warm-700',
  'bg-brand-50 text-brand-700 ring-1 ring-brand-100',
]

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  const first = Array.from(parts[0] ?? '?')[0] ?? '?'
  const last = parts.length > 1 ? (Array.from(parts[parts.length - 1]!)[0] ?? '') : ''
  return (first + last).toUpperCase()
}

export function Avatar({
  name,
  size = 'md',
  className,
}: {
  name: string
  size?: 'xs' | 'sm' | 'md' | 'lg'
  className?: string
}) {
  let h = 0
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) >>> 0
  const sz = { xs: 'size-6 text-[10px]', sm: 'size-8 text-12', md: 'size-9 text-13', lg: 'size-12 text-16' }[
    size
  ]
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-grid shrink-0 place-items-center rounded-full font-semibold select-none',
        sz,
        TINTS[h % TINTS.length],
        className,
      )}
    >
      {initials(name)}
    </span>
  )
}
